module.exports = __webpack_public_path__ + "static/media/mh_entrium_main.84313348.png";